var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"ref",staticClass:"icon",attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.use)},on:{"click":function (e) { return this$1.$emit('click', e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }